export const Diploma = [
	'Aucun diplôme',
	'Brevet des collèges',
	'Diplôme Professionnel: CAP ou BEP',
	'Baccalauréat',
	'Licence, Bac +1 à 3',
	'Master, Bac +4 à 5',
	'École de commerce, école d\'ingénieur, doctorat'
]

export const Level = [
	'Novice',
	'Plutôt expérimenté',
	'Expérimenté',
	'Très expérimenté'
]

export const Age = [
	'Entre 0 et 5 ans',
	'Entre 6 et 10 ans',
	'Entre 11 et 20 ans',
	'Plus de 20 ans'
]

export const Country = [
	'Nettement meilleur',
	'Un peu meilleur',
	'A peu près le même',
	'Un peu moins bon',
	'Nettement moins bon'
]

export const Product = [
	'Placements monétaires/Livrets/autres placements de trésorerie',
	'Fonds en euros',
	'Obligations et/ou fonds obligataires',
	'Actions et/ou fonds actions',
	'OPCI et/ou SCPI',
	'Produits structurés',
	'Titres de créance et/ou parts et/ou actions de sociétés non côtées',
	'Assurances-vie',
	'Contrat de capitalisation',
	'PEA',
	'Compte-titres',
	'Aucun'
]

export const InvestedProduct = [
	'Placements monétaires/Livrets/autres placements de trésorerie',
	'Fonds en euros',
	'Obligations et/ou fonds obligataires',
	'Actions et/ou fonds actions',
	'OPCI et/ou SCPI',
	'Produits structurés',
	'Titres de créance et/ou parts et/ou actions de sociétés non côtées',
	'Assurances-vie',
	'Contrat de capitalisation',
	'PEA',
	'Compte-titres',
	'Aucun'
]

export const Management = [
	'Mandat de gestion',
	'Gestion conseillée',
	'Gestion libre'
]



// WEBPACK FOOTER //
// ./src/common/components/MyPatrimonialLandscape/data/Knowledge.js